import React from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { MapPin, Clock } from "react-feather";
import { paths } from "../../../../routes/paths";

// Current location pin (handoff §19) - read-only everywhere on the web,
// only ever written by a Flutter QR scan. Customers.ViewLocation-gated
// (admin/manager-only by default) - this whole panel is skipped for
// callers without it, same as the field-visit history page it links to.
const CustomerLocationPanel = ({ branchId, custId, latitude, longitude, locationUpdatedAt, locationSourceName }) => {
  const navigate = useNavigate();
  const hasLocation = latitude != null && longitude != null;

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Current Location</h5>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => navigate(paths.customerFieldVisits(branchId, custId))}
          >
            View Field-Visit History
          </button>
        </div>
        {hasLocation ? (
          <div className="d-flex flex-wrap gap-4">
            <div className="d-flex align-items-center gap-2">
              <MapPin size={16} className="text-muted" />
              <span>{Number(latitude).toFixed(6)}, {Number(longitude).toFixed(6)}</span>
            </div>
            <div className="d-flex align-items-center gap-2 text-muted small">
              <Clock size={14} />
              <span>
                {locationUpdatedAt ? dayjs(locationUpdatedAt).format("DD-MMM-YYYY HH:mm") : "-"}
                {locationSourceName ? ` · scanned by ${locationSourceName}` : ""}
              </span>
            </div>
          </div>
        ) : (
          <p className="text-muted mb-0">No location recorded yet - set the first time this customer is scanned in the field.</p>
        )}
      </div>
    </div>
  );
};

export default CustomerLocationPanel;
